import { useDispatch, useSelector } from 'react-redux'
import { Callback } from 'lib/types'
import { getAccountRequiresConfirmation } from 'lib/core/data/common/storeConfig/selectors'
import { createAccount } from 'lib/core/data/customer/createAccount'
import {
  getIsFetching as getCreateAccountFetching,
  getIsFailure as getCreateAccountFailure,
  getError as getCreateAccountError
} from 'lib/core/data/customer/createAccount/selectors'
import { Ga4Events } from '../../../gtm/index'

export interface CreateAccountHookOptions {
  callback?: Callback
}

export interface CreateAccountAddress {
  city: string
  country_id: string
  default_shipping: boolean
  default_billing: boolean
  firstname: string
  lastname: string
  company?: string
  postcode: string
  region_id?: number
  street: Array<string | undefined>
  telephone: string
}
export interface CreateAccountData {
  firstName: string
  lastName: string
  email: string
  password: string
  extensionAttributes?: Record<string, any>
  address?: CreateAccountAddress
  gender?: number
  dob?: string
}

export const useCreateAccount = () => {
  const dispatch = useDispatch()
  const createAccountErrorCode = useSelector(getCreateAccountError)
  const createAccountIsFetching = useSelector(getCreateAccountFetching)
  const createAccountIsFailure = useSelector(getCreateAccountFailure)
  const accountRequiresConfirmation = Boolean(useSelector(getAccountRequiresConfirmation))

  return {
    isFetching: createAccountIsFetching,
    isFailure: createAccountIsFailure,
    errorCode: createAccountErrorCode,
    requiresConfirmation: accountRequiresConfirmation,

    createAccount: (data: CreateAccountData, options: CreateAccountHookOptions) => {
      const extensionAttr = data.extensionAttributes ? { extension_attributes: data.extensionAttributes } : {}
      const addresses = data.address && [data.address]
      const gender = data.gender
      const dob = data.dob
      dispatch(createAccount({
        customer: {
          firstname: data.firstName,
          lastname: data.lastName,
          email: data.email,
          gender,
          dob,
          addresses,
          ...extensionAttr
        },
        password: data.password
      }, {
        onSuccess: options?.callback?.onSuccess,
        onFailure: options?.callback?.onFailure
      }))
      Ga4Events.signUp({ method: 'email' })
    }
  }
}
